(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[820],{

/***/ 5353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(6736);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1277);
/* harmony import */ var utils_logging__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4453);
/* harmony import */ var _hooks_UserContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2344);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4361);







function Error() {
    const { 0: recommendationCards , 1: setRecommendationCards  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const user = (0,_hooks_UserContext__WEBPACK_IMPORTED_MODULE_4__/* .useUserState */ .e)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const fetchRecommendedJobs = async ()=>{
            try {
                const response = await (0,_utils_api__WEBPACK_IMPORTED_MODULE_5__/* .fetchJobRecommendations */ .zA)();
                setRecommendationCards(response.results.map((job)=>({
                        companyName: job.company_name,
                        jobTitle: job.name,
                        location: job.location_values[0],
                        companyLogoUrl: job.company_logo_image,
                        jobUrl: job.apply_link
                    })));
            } catch (error) {
                const msg = `${"search-renderer"} was unable fetch recommended jobs.`;
                console.error(msg, JSON.stringify((0,utils_logging__WEBPACK_IMPORTED_MODULE_3__/* .formatLog */ .U)({
                    error
                })));
            }
        };
        fetchRecommendedJobs();
    }, []);
    /* eslint-disable max-len */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Find The Best Jobs at Companies Hiring Now | The Muse"
                    }, "title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Stars have aligned: I just found some awesome open jobs at Companies Hiring Now on The Muse. If you're looking for a new gig, check it out."
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Find The Best Jobs at Companies Hiring Now | The Muse"
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.themuse.com/static/images/muse-og-image.png"
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Stars have aligned: I just found some awesome open jobs at Companies Hiring Now on The Muse. If you're looking for a new gig, check it out."
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex, follow"
                    }, "robots"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "https://public-assets.themuse.com/images/favicons/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "https://public-assets.themuse.com/images/favicons/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "https://public-assets.themuse.com/images/favicons/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "manifest",
                        href: "https://public-assets.themuse.com/images/favicons/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "mask-icon",
                        href: "https://public-assets.themuse.com/images/favicons/safari-pinned-tab.svg",
                        color: "#9ADBF5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        href: "https://public-assets.themuse.com/images/favicons/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "apple-mobile-web-app-title",
                        content: "The Muse"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "application-name",
                        content: "The Muse"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#9ADBF5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "msapplication-config",
                        content: "https://public-assets.themuse.com/images/favicons/browserconfig.xml"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "theme-color",
                        content: "#9ADBF5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_themuse_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                pageName: "error-page",
                pageId: "error-content",
                recommendationCards: recommendationCards,
                user: user
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Error);


/***/ }),

/***/ 1277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ErrorPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Error/Error.module.scss
var Error_module = __webpack_require__(8462);
var Error_module_default = /*#__PURE__*/__webpack_require__.n(Error_module);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Text/Text.tsx
var Text = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowRightShape.tsx
var ArrowRightShape = __webpack_require__(7621);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/node_modules/classnames/index.js
var classnames = __webpack_require__(1401);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/CompanyLogoOutlined/CompanyLogoOutlined.module.scss
var CompanyLogoOutlined_module = __webpack_require__(1980);
var CompanyLogoOutlined_module_default = /*#__PURE__*/__webpack_require__.n(CompanyLogoOutlined_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/CompanyLogoOutlined/CompanyLogoOutlined.tsx




const CompanyLogoOutlined = (props)=>{
    const { altText , companyUrl , logoUrl , className , extraLinkProps  } = props;
    const { 0: image404 , 1: setImage404  } = (0,react.useState)(false);
    const disableFocusClick = (event)=>{
        event.currentTarget.blur();
        event.stopPropagation();
    };
    const image404Callback = ()=>{
        setImage404(true);
    };
    const Pill = ()=>image404 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Company Logo"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            onError: image404Callback,
            alt: altText,
            height: "48",
            loading: "lazy",
            src: logoUrl,
            width: "108",
            ...extraLinkProps
        });
    const classNames = classnames_default()(companyUrl ? (CompanyLogoOutlined_module_default()).pillLink : (CompanyLogoOutlined_module_default()).logoPill, className, image404 ? (CompanyLogoOutlined_module_default()).image404 : "");
    return companyUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: classNames,
        href: companyUrl,
        onMouseUp: disableFocusClick,
        ...extraLinkProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {})
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classNames,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {})
    });
};


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobRecommendationCard.module.scss
var JobRecommendationCard_module = __webpack_require__(5726);
var JobRecommendationCard_module_default = /*#__PURE__*/__webpack_require__.n(JobRecommendationCard_module);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobRecommendationCard.tsx





const JobRecommendationCard = (props)=>{
    const { classes , companyName , jobTitle , location , companyLogoUrl , jobUrl , onClick  } = props;
    const enableTooltip = companyName.length >= 35 || jobTitle.length >= 35;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes?.jobRecommendationCard || (JobRecommendationCard_module_default()).jobRecommendationCard,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: jobUrl,
            onClick: onClick,
            className: classes?.link || (JobRecommendationCard_module_default()).link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes?.container || (JobRecommendationCard_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogoOutlined, {
                        altText: `${companyName} Logo`,
                        className: classes?.logoPill || (JobRecommendationCard_module_default()).logoPill,
                        logoUrl: companyLogoUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes?.content || (JobRecommendationCard_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes?.companyName || (JobRecommendationCard_module_default()).companyName,
                                children: companyName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes?.jobTitle || (JobRecommendationCard_module_default()).jobTitle,
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes?.footer || (JobRecommendationCard_module_default()).footer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes?.location || (JobRecommendationCard_module_default()).location,
                                        children: location
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes?.viewJob || (JobRecommendationCard_module_default()).viewJob,
                                        children: [
                                            "View Job ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightShape/* default */.Z, {
                                                height: 16
                                            })
                                        ]
                                    })
                                ]
                            }),
                            enableTooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classes?.tooltip || (JobRecommendationCard_module_default()).tooltip,
                                role: "tooltip",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes?.tooltipContainer || (JobRecommendationCard_module_default()).tooltipContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes?.tooltipCompany || (JobRecommendationCard_module_default()).tooltipCompany,
                                            children: companyName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes?.tooltipTitle || (JobRecommendationCard_module_default()).tooltipTitle,
                                            children: jobTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes?.tooltipLocation || (JobRecommendationCard_module_default()).tooltipLocation,
                                            children: location
                                        })
                                    ]
                                })
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
};


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Error/Error.tsx






const Error = (props)=>{
    const { recommendationCards =[] , ...restProps } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ...restProps,
        className: (Error_module_default()).error,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Error_module_default()).errorMessage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: (Error_module_default()).errorH1,
                        htmlTag: "h1",
                        textStyle: "heading-1",
                        children: "Oops! We couldn't find this page."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: (Error_module_default()).errorParagraph,
                        htmlTag: "p",
                        textStyle: "sans-serif-body",
                        children: "Luckily, we have some suggestions of great jobs on our site!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                        href: "/search?searchType=jobs&tm_source=error_page",
                        className: (Error_module_default()).errorCTA,
                        color: "mint",
                        children: "Explore Jobs"
                    })
                ]
            }),
            !!recommendationCards.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (Error_module_default()).jobRecommendations,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: (Error_module_default()).jobRecommendationsTitle,
                        htmlTag: "h3",
                        textStyle: "heading-3",
                        children: "Jobs On The Muse"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Error_module_default()).jobRecommendationCards,
                        children: recommendationCards.map((cardProps)=>{
                            const { jobUrl  } = cardProps;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobRecommendationCard, {
                                classes: {
                                    jobRecommendationCard: (Error_module_default()).jobRecommendationCard
                                },
                                ...cardProps
                            }, jobUrl);
                        })
                    })
                ]
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Pages/Layout.tsx + 19 modules
var Layout = __webpack_require__(318);
;// CONCATENATED MODULE: ./node_modules/@themuse/design-system/lib/components/Pages/ErrorPage.tsx




const ErrorPage = (props)=>{
    const { pageName ="error-page" , pageId ="error-content" , user , recommendationCards , handleModalFormSubmit =()=>{
        console.error("Design System: Newsletter handleModalFormSubmit not supplied to the ErrorPage!");
        return Promise.resolve(false);
    }  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageName: pageName,
        pageId: pageId,
        user: user,
        handleModalFormSubmit: handleModalFormSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
            recommendationCards: recommendationCards
        })
    });
};



/***/ }),

/***/ 5726:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobRecommendationCard":"JobRecommendationCard_jobRecommendationCard__G9CwW","tooltip":"JobRecommendationCard_tooltip__8vpPl","container":"JobRecommendationCard_container__z9XsZ","link":"JobRecommendationCard_link__SomGO","content":"JobRecommendationCard_content__lt0Lp","logoPill":"JobRecommendationCard_logoPill__uppFE","companyName":"JobRecommendationCard_companyName__sFAO4","jobTitle":"JobRecommendationCard_jobTitle__BjO42","footer":"JobRecommendationCard_footer__nQOj5","location":"JobRecommendationCard_location__rsFVH","viewJob":"JobRecommendationCard_viewJob__bn3tm","tooltipContainer":"JobRecommendationCard_tooltipContainer__DnApr","tooltipCompany":"JobRecommendationCard_tooltipCompany__Q3E6D","tooltipTitle":"JobRecommendationCard_tooltipTitle__UP_Vv","tooltipLocation":"JobRecommendationCard_tooltipLocation__VXSF4"};

/***/ }),

/***/ 1980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logoPill":"CompanyLogoOutlined_logoPill__weBC5","image404":"CompanyLogoOutlined_image404__vqL0s","pillLink":"CompanyLogoOutlined_pillLink__INFGN CompanyLogoOutlined_logoPill__weBC5"};

/***/ }),

/***/ 8462:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__WjYoU","errorMessage":"Error_errorMessage__PmbIN","errorH1":"Error_errorH1__5VxpZ","errorParagraph":"Error_errorParagraph__aBo2l","errorCTA":"Error_errorCTA__Wo52n","jobRecommendations":"Error_jobRecommendations__qM2S6","jobRecommendationsTitle":"Error_jobRecommendationsTitle__LeS4x","jobRecommendationCards":"Error_jobRecommendationCards__aPhC1","jobRecommendationCard":"Error_jobRecommendationCard__EX3xt JobRecommendationCard_jobRecommendationCard__G9CwW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [990,652,774,888,179], function() { return __webpack_exec__(5353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);